module.exports = __webpack_public_path__ + "static/img/no-data.af4bbca1.png";